var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Recycled","chart":"column","chartType":"recycled","isCity":false,"withDate":true,"withFinancial":false,"recycled":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }